import * as React from "react";
import { PivotBarItem, IPivotBarAction, IPivotBarViewAction } from "VSSUI/PivotBar";
import { IObservableArray } from "VSS/Core/Observable";

export interface IWorkItemsHubNavBarOptions {
    content : JSX.Element 
    commands: IPivotBarAction[];
    viewActions?: IObservableArray<IPivotBarViewAction>;
}

/*
 * Creates nav bar above work item form to return to previous work item pivot.
 * Also renderes triage view buttons if triage data is available
 */
export function createWorkItemsHubNavBar(options : IWorkItemsHubNavBarOptions): JSX.Element {

    return (
        <PivotBarItem name="main" itemKey="main" className="customPadding" commands={options.commands} viewActions={options.viewActions}>
            {options.content}
        </PivotBarItem>
    );
}